import { useMemo } from 'react';
import type { Member } from '../types';

// Returns a sort-group index for tri-group ordering:
// 0 = primary, 1 = non-pediatric, 2 = pediatric
function sortGroup(member: Member): number {
  if (member.isPrimary) return 0;
  if (member.plan === 'Pediatrics') return 2;
  return 1;
}

// Sorts members: primary first, then non-pediatric adults (eldest first),
// then pediatric members (youngest first).
export function sortMembers(members: Member[]): Member[] {
  return [...members].sort((a, b) => {
    const groupA = sortGroup(a);
    const groupB = sortGroup(b);

    if (groupA !== groupB) return groupA - groupB;

    // Within non-pediatric (group 1): ascending DOB → eldest first
    if (groupA === 1) return a.date_of_birth.localeCompare(b.date_of_birth);

    // Within pediatric (group 2): descending DOB → youngest first
    if (groupA === 2) return b.date_of_birth.localeCompare(a.date_of_birth);

    return 0;
  });
}

export function useSortedMembers(members: Member[]): Member[] {
  return useMemo(() => sortMembers(members), [members]);
}
